import { Injectable } from '@angular/core';
import { Experience } from '@app/utils/models/itinerary/experience.model';
import { ItineraryState } from '@app/utils/models/store/itinerary-state.model';

@Injectable({
  providedIn: 'root',
})
export class ItineraryReducerService {
  updateExperience(state: ItineraryState, index: number, experience: Experience): ItineraryState {
    const days = state.days.map(d => ({
      ...d,
      experiences: d.experiences.map(e => (e.id === index ? experience : e)),
    }));
    return { ...state, days };
  }
}
